export class FiltroAvancadoBody {
    bairro: string;
    codCidade: number;
    codPais: number;
    codContrato: number[] = [];
    codEstado: string;
    comodidades: string[] = [];
    tipoComodidade: any[] = [];
    numeroPagina: number;
    qtdPorPagina: number;
    regimesAlimentacao: string[] = [];
    regimeAlimentacao: string[] = [];
    tipoApartamento: string[] = [];
    tipoHotel: string[] = [];
    hotel: string[] = [];
    tipoPlano: string[] = [];
    tipoQuarto: string[] = [];
    criancaGratis: string[] = [];
}
